var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4062 2.77969L14.8188 3.58906L6.81875 14.5891L6.13125 15.5359C6.10938 15.5141 4.5 13.9047 1.30313 10.7078L0.59375 10.0016L2.00938 8.58594C2.06875 8.64531 3.3625 9.93906 5.8875 12.4641L13.2 2.41094L13.7875 1.60156L15.4062 2.77656V2.77969Z",
    fill: "#091644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickMark);
export default __webpack_public_path__ + "static/media/tick-mark.43b71e068b9975fbaf027fff155a8f31.svg";
export { ForwardRef as ReactComponent };